import React from 'react';
import {
	Grid,
} from '@material-ui/core';
import {CancelFormButton} from "../../../components/CancelFormButton";
import {Breadcrumbs} from "../../../components/Breadcrumbs";
import {useTranslation} from "react-i18next";

const Header = ({ isNew }) => {

    const { t }  = useTranslation();

	const currentPath = [
        { 'name' : t('Cameras'), 'url' : '/app/cameras'},
        { 'name' : isNew ? t('Create') : t('Edit'), 'url' : ''},
    ];

	return (
		<Grid
			container
			spacing={3}
			justifyContent="space-between"
		>
            <Breadcrumbs path={currentPath} />
            <CancelFormButton url="/app/cameras" />

		</Grid>
	);
};
export default Header;
